/**
 * Default text to display in Pagination Pages when there are many pages available between current page and end page.
 * @returns "..."
 */
export const DEFAULT_PAGINATION_MOREPAGES_SEPARATOR: string = '...';

/**
 * Default number of consecutive pages to display back to user.
 * @returns 2
 */
export const DEFAULT_PAGINATION_PAGE_DELTA: number = 2;

/**
 * Default Page Size options to display number of rows per Page within Table.
 */
export const DEFAULT_PAGINATION_OPTIONS = [
  { title: '10', value: 10 },
  { title: '20', value: 20 },
  { title: '30', value: 30 },
  { title: '40', value: 40 },
  { title: '50', value: 50 },
];
